<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import 'aos/dist/aos.css'
import AOS from 'aos/dist/aos.js'
export default {
  name: 'App',
  mounted () {
    AOS.init({
      offset: 200,
      duration: 600,
      easing: 'ease-in-sine',
      delay: 100
    })
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue